import { Chip, PropTypes } from '@mui/material';
import { useWeaveThemeContext } from '@innovyze/stylovyze';
import * as React from 'react';

export type TextIndicatorProps = {
	readonly textColor: string;
	readonly iconColor: string;
	readonly avatar?: React.ReactElement;
	readonly children?: null;
	readonly clickable?: boolean;
	readonly color?: Exclude<PropTypes.Color, 'inherit'>;
	readonly deleteIcon?: React.ReactElement;
	readonly disabled?: boolean;
	readonly icon?: React.ReactElement;
	readonly label?: React.ReactNode;
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	readonly onDelete?: React.EventHandler<any>;
	readonly size?: 'small' | 'medium';
	readonly variant?: 'filled' | 'outlined';
};

/**
 * Chip with overridable colors
 */
export default function GeneralSettingsTextIndicator(
	props: TextIndicatorProps,
) {
	const { textColor, iconColor, ...chipProps } = props;
	const { isWeaveTheme } = useWeaveThemeContext();
	return (
		<span data-testid="TextIndicator">
			<Chip
				{...chipProps}
				sx={{
					border: isWeaveTheme ? textColor : 'none',
					color: textColor,
					'& .MuiChip-icon': { color: iconColor },
					'& .MuiChip-label': { color: textColor },
				}}
			/>
		</span>
	);
}
